$(function () {
	var nowPercent = 0;
	var displayingPercent = 0;
	var loadImgNum = 0;
	var loadedImgNum = 0;
	loadImgNum = $("#mainVisual img").length;

	const flowSwiper = new Swiper(".flowSwiper", {
		loop: true,
		autoplay: {
			delay: 0,
			disableOnInteraction: true,
		},
		speed: 4000,
		//effect: "slide",
		spaceBetween: 0,
		slidesPerView: 3.5,
		slideToClickedSlide: false,
		allowTouchMove: false,
		spaceBetween: 0,
		centeredSlides: false,

		breakpoints: {
			719: {
				slidesPerView: 4.5,
			},
		},
	});

	const reviewSwiper = new Swiper(".reviewSwiper", {
		loop: true,
		autoplay: {
			delay: 1000,
		},
		speed: 600,
		//effect: "slide",
		spaceBetween: 0,
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 30,
		//centeredSlides: true,

		// Navigation arrows
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},

		breakpoints: {
			719: {
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
		},
	});

	reviewSwiper.autoplay.stop();

	//読み込んだらカウント
	$(".mainVisual img").each(function (index) {
		$(this).imagesLoaded(function () {
			loadedImgNum++;
			//console.log(loadedImgNum);

			$(window).trigger("resize");
		});
	});

	//$("html,body").addClass("hidden");

	// LOADING
	var checkload = function (ev) {
		nowPercent = Math.ceil((100 * loadedImgNum) / loadImgNum);
		//console.log(displayingPercent);

		if (displayingPercent >= 100) {
			//console.log("complete");
			setTimeout(showImg, 0);
			setTimeout(showDesp, 600);
			//setTimeout(startSlider, 1600);
		} else {
			setTimeout(checkload, 10);

			if (displayingPercent < nowPercent) {
				//本当のパーセントで表示させたい時
				displayingPercent = Math.ceil((100 * loadedImgNum) / loadImgNum) + 1;

				//ちょっと遅延表示させたい時
				if (displayingPercent < nowPercent) {
					//displayingPercent = displayingPercent + 2;
				}
			}
		}
	};
	var timer = setTimeout(checkload, 10);

	function showImg() {
		$(".mainVisual .img").addClass("active");
	}
	function showDesp() {
		$(".mainVisual .despArea").addClass("active");
	}
	function startSlider() {
		topSwiper.autoplay.start();
	}
});
